import type { Release } from '../releases.ts';

export default {
  version: '0.97.0',
  date: '2026-10-09',
  title: 'Sequence edit lock',
  summary: [
    'One person edits a sequence at a time; others open it read only',
    'Ask to edit, and the person editing can hand over or dismiss',
    'Administrators and media managers can take over a sequence',
    'The sequence list shows who is editing each sequence',
    'Fixed: false “Someone else saved this sequence” warnings when adding clips',
  ],
  features: [
    'One person edits a sequence at a time. Others open it read only (play, scrub, inspect and export the saved revision) with “Being edited by Elin since 10:42”; it follows the editor’s saves and offers Start editing once nobody is editing',
    'Ask to edit: the person editing sees the request and can Hand over (their edits are saved first) or Dismiss; you are told either way',
    'Take over, for administrators and media managers (the new permission Take over sequences, in Access → Roles): the other person’s edits are saved first and their editor turns read only. If their tab does not answer within 10 seconds, the sequence is yours anyway',
    'The same sequence in a second tab or on another computer opens read only, with Edit here instead',
    'The sequence list shows a lock with the name of whoever is editing',
    'An editor left open keeps the sequence for as long as the tab is open; closing it, signing out or the idle sign-out frees it, and so does a lost connection after 90 seconds',
  ],
  fixes: [
    'Appending or dropping a clip no longer shows “Someone else saved this sequence” when nobody did: opening a sequence again in the same session started from an older copy, and every save after it was refused. The editor also stopped retrying a refused save every 0.7 s, which made the warning flicker',
  ],
} satisfies Release;
